"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var RadioButtonChecked_1 = __importDefault(require("@mui/icons-material/RadioButtonChecked"));
var RadioButtonUnchecked_1 = __importDefault(require("@mui/icons-material/RadioButtonUnchecked"));
require("../../scss/_forms.scss");
/**
 * @component Radio
 * @example
 *
 * <Radio
 *    id={index.toString()}
 *    name="paymentMethod"
 *    label={"Label text"}
 *    value={index.toString()}
 *    checked={index.toString() === formik.values['paymentMethod']}
 *    onChange={formik.handleChange}
 *  />
 *
 * @param { number | string} id formik id
 * @param {string} name formik name
 * @param {string} label label text
 * @param {string} value value of the radio
 * @param {function} onChange fn for changing radio use formik handlechange
 * @param {boolean} checked either true or false
 * @param {number} marginTop margin on top of radio
 * @param {number} marginBottom margin on bottom of radio
 *
 */
var Radio = function (props) {
    var id = props.id, name = props.name, label = props.label, value = props.value, onChange = props.onChange, _a = props.checked, checked = _a === void 0 ? false : _a, _b = props.marginTop, marginTop = _b === void 0 ? 2 : _b, _c = props.marginBottom, marginBottom = _c === void 0 ? 2 : _c;
    return (react_1.default.createElement("label", { className: "radio mt-".concat(marginTop, " mb-").concat(marginBottom), htmlFor: "radio-".concat(id) },
        react_1.default.createElement("input", { id: "radio-".concat(id), type: "radio", name: name, checked: checked, value: value, onChange: onChange }),
        react_1.default.createElement("span", { className: "radio-on" },
            react_1.default.createElement(RadioButtonChecked_1.default, null)),
        react_1.default.createElement("span", { className: "radio-off" },
            react_1.default.createElement(RadioButtonUnchecked_1.default, null)),
        react_1.default.createElement("span", { className: "label" }, label)));
};
exports.default = Radio;
